import clsx from 'clsx';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useContext } from 'react';
import { T, TranslationsContext, translation } from '../../Translations';
import InfoIcon from './InfoIcon';
import StopImpersonatingButton from './StopImpersonatingButton';

interface Props {
  impersonatingBy: Maybe<string>;
}

const ImpersonationMessage: React.FC<Props> = ({ impersonatingBy }) => {
  const ts = useContext(TranslationsContext);

  return impersonatingBy
    .map((email) => (
      <div
        role="region"
        aria-label={translation('Admin impersonation notice')(ts)}
        className={clsx(
          'mx-auto bg-secondary text-foreground',
          'whitespace-pre-line border-b-2 border-solid text-sm',
          'border-primary',
        )}
        data-intercom-target="impersonation-banner"
      >
        <div
          className={clsx(
            'mx-auto py-2 px-12 max-w-clientPortalMaxWidth flex items-center justify-between',
          )}
        >
          <div className="flex items-center">
            <InfoIcon />
            <T kind="Impersonating by {{emailAddress}}" emailAddress={email} />
          </div>
          <StopImpersonatingButton />
        </div>
      </div>
    ))
    .getOrElse(() => <></>);
};

export default observer(ImpersonationMessage);
